import { render, staticRenderFns } from "./move-chart.vue?vue&type=template&id=32332cf4&scoped=true&"
import script from "./move-chart.vue?vue&type=script&lang=js&"
export * from "./move-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32332cf4",
  null
  
)

export default component.exports